
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e-commerce-development",
      function () {
        return require("private-next-pages/e-commerce-development.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/e-commerce-development"])
      });
    }
  